import { Link } from 'react-router';

import SeoHead from '../components/seo/SeoHead';
import StickyNavbar from '../components/navbar/StickyNavbar';
import Footer from '../components/landing/Footer';

export default function NotFoundPage() {
  return (
    <div className="w-full min-h-screen bg-white text-gray-800 flex flex-col">
      <SeoHead route="/404" />
      <StickyNavbar />

      <main className="flex flex-col flex-1 items-center justify-center py-20 md:py-24 px-4 text-center">
        <h1 className="text-3xl sm:text-5xl font-extrabold mb-4 tracking-tight">
          Page not found
        </h1>
        <p className="text-gray-600 mb-8 max-w-md text-sm sm:text-lg">
          The page you are looking for does not exist.
        </p>
        <Link
          to="/"
          className="bg-green-700 text-white px-6 py-3 rounded-lg text-base font-medium sm:text-lg hover:bg-green-800 shadow-lg hover:shadow-xl transition-shadow">
          Back to home
        </Link>
      </main>

      <Footer />
    </div>
  );
}
